import type { PolicyHeaderObject } from '@wix/cookie-consent-policy-client';

// NOTE: https://github.com/wix-private/consent-policy-service/tree/master/cookie-consent-policy-client
export default {
  _getConsentPolicyHeader(): PolicyHeaderObject {
    return window.consentPolicyManager?._getConsentPolicyHeader() ?? {};
  },
};
